import { useSelector } from "react-redux";

export const useGetAuthenticatedEntry = () => {
  //   const userInfo = useSelector((state) => state.auth.user);
  const userInfo = JSON.parse(localStorage?.getItem("user"));
  const role = userInfo?.role?.dev_code;

  const authenticatedEntryPath =
    role === "setup_admin" ? "/news" : "/departments";
  console.log(
    "the value of authenticated entry path is inside hook ---------------->>",
    authenticatedEntryPath
  );

  return { authenticatedEntryPath };
};
